import { apiClient } from '../client';

const PPGController = apiClient.ppg;

export { PPGController };
